'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _momentTimezone = require('moment-timezone');

var _momentTimezone2 = _interopRequireDefault(_momentTimezone);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    isAlwaysAvailable: function isAlwaysAvailable(openingTimes) {
        return !openingTimes;
    },
    momentizeMinuteOfWeek: function momentizeMinuteOfWeek(minuteOfWeek) {
        var _moment = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _momentTimezone2.default;

        var firstWeekday = this.getFirstWeekday(_moment());
        var momentized = firstWeekday.clone().add(minuteOfWeek, "m");
        var dstOffset = momentized.utcOffset() - firstWeekday.utcOffset();
        return momentized.add(-dstOffset, 'm');
    },
    getWeekdayFromMinuteOfWeek: function getWeekdayFromMinuteOfWeek(minuteOfWeek) {
        var _moment = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _momentTimezone2.default;

        return this.momentizeMinuteOfWeek(minuteOfWeek, _moment).isoWeekday() % 7;
    },
    getMinuteOfWeek: function getMinuteOfWeek(date) {
        var firstWeekday = this.getFirstWeekday(date);
        return date.diff(firstWeekday, "minutes");
    },
    getFirstWeekday: function getFirstWeekday(date) {
        return date.isoWeekday() % 7 === 0 ? date.clone().startOf("d") : date.clone().startOf("isoWeek").add(-1, "d");
    },
    getWeekdayName: function getWeekdayName(weekday) {
        var _moment = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _momentTimezone2.default;

        return _moment().day(weekday).format("dddd");
    },
    assignTimeToDate: function assignTimeToDate(date, time) {
        return date.hours(time.hours()).minutes(time.minutes());
    },
    isSameDay: function isSameDay(date1, date2) {
        return date1.clone().startOf("d").diff(date2.clone().startOf("d")) === 0;
    },
    isSameTime: function isSameTime(date1, date2) {
        return date1.hours() === date2.hours() && date1.minutes() === date2.minutes();
    },
    extractTime: function extractTime(dateTime, _moment) {
        var time = dateTime.clone();
        return _moment().hours(time.hours()).minutes(time.minutes()).seconds(time.seconds()).milliseconds(time.milliseconds());
    },
    startOfNextDay: function startOfNextDay(date) {
        return date.clone().add(1, "d").startOf("d");
    },
    isToday: function isToday(date) {
        var _moment = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _momentTimezone2.default;

        return this.isSameDay(date, _moment());
    },
    isBeforeToday: function isBeforeToday(date) {
        var _moment = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _momentTimezone2.default;

        return date < _moment().clone().startOf("d");
    },
    isPast: function isPast(date) {
        var _moment = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _momentTimezone2.default;

        return date < _moment();
    },
    datesEqual: function datesEqual(d1, d2) {
        return d1.diff(d2) === 0;
    },
    getUtcOffset: function getUtcOffset() {
        var timezone = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _momentTimezone2.default.tz.guess();

        return _momentTimezone2.default.tz(timezone).utcOffset();
    },
    getTimeUnitFromMinutes: function getTimeUnitFromMinutes(minutes) {
        if (minutes % (24 * 60) === 0) return { value: minutes / (24 * 60),
            unit: 'days' };

        if (minutes % 60 === 0) return { value: minutes / 60,
            unit: 'hours' };

        return { value: minutes,
            unit: 'minutes' };
    },
    getMinutesFromTimeUnit: function getMinutesFromTimeUnit(value, unit) {
        var minutes = void 0;
        value = Number(value);

        switch (unit) {
            case 'minutes':
                minutes = value;
                break;
            case 'hours':
                minutes = value * 60;
                break;
            case 'days':
                minutes = value * 60 * 24;
                break;
        }

        return minutes;
    },
    humanizeMinutesDuration: function humanizeMinutesDuration(mins) {
        var _moment = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _momentTimezone2.default;

        var _getTimeUnitFromMinut = this.getTimeUnitFromMinutes(mins),
            value = _getTimeUnitFromMinut.value,
            unit = _getTimeUnitFromMinut.unit;

        var momentUnit = unit[0];
        var relativeTimeUnit = value === 1 ? momentUnit : momentUnit + momentUnit;
        return _moment.localeData().relativeTime(value, true, relativeTimeUnit, false);
    },
    serializeDate: function serializeDate(date) {
        var result = null;

        if (date) {
            if (!_momentTimezone2.default.isMoment(date)) {
                date = (0, _momentTimezone2.default)(date);
            }
            var year = date.year();
            var month = pad(date.month() + 1);
            var day = pad(date.date());
            result = year + '-' + month + '-' + day;
        }

        return result;
    }
};


function pad(num) {
    return num < 10 ? '0' + num : num;
}


//////////////////
// WEBPACK FOOTER
// ../node_modules/@wix/wixrest-utils/dist/Time.js
// module id = 271
// module chunks = 0